import React from 'react';
import CMPImage from 'components/global/image';

const LandIcon: React.FunctionComponent = () => {
  const src = '/images/lands.png';
  return <CMPImage asset={{ src, alt: 'Character' }} width={16} height={18} />;
};

export default LandIcon;
